import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useLocation } from 'react-router-dom';

const ThankYou: React.FC = () => {
  const location = useLocation();
  const message = location.state?.message || "";
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 5 },
          maxWidth: 600,
          textAlign: 'center',
          borderRadius: 3,
        }}
      >
        <CheckCircleOutlineIcon
          sx={{
            fontSize: 70,
            color: 'success.main',
            mb: 2,
          }}
        />
        <Typography variant="h4" component="h1">
          Thank You
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {message  || "Your details and documents have been submitted successfully. Our team will review your submission and contact you if any further information is required."}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ThankYou;
